import React from 'react';
import { injectIntl } from 'react-intl';
import { faQuestion, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './HelpList.scss';


const HelpList = (props) => {

    const fm = ({ id }) => props.intl.formatMessage({ id });

    const showHelpItem = ({ item }) => {
        if (item && item.intl) {
            return (
                <>
                    <div className="helplist-group">
                        <label><FontAwesomeIcon icon={faQuestion} />{fm({ id: "advanced.question" })}</label>
                        <div>{item.intl}</div>
                    </div>
                    <div className="helplist-group">
                        <label><FontAwesomeIcon icon={faUser} />{fm({ id: "advanced.answer" })}</label>
                        <div>{item.value}</div>
                    </div>
                </>
            )
        }
        return null;
    }

    const showAll = () => {
        return (
            <span className="helplist-showall" onClick={props.onShowAll}>
                {fm({ id: 'advanced.showAll' })}
            </span>
        );
    }

    return (
        <div className="helplist-list">
            {props.helpCur ? showHelpItem({ item: props.helpCur }) : props.data.map(item => showHelpItem({ item }))}
            {props.helpCur && showAll()}
        </div>
    )
}

export default injectIntl(HelpList);